Wee.fn.make('planning', {
	_construct: function() {
		this.planningSwiper;
	},

	init: function() {
		if ($('ref:planningSwiper').length) {
			this.planningSwiper = new Swiper('.planning-swiper', {
				pagination: '.swiper-pagination.-planning',
				paginationClickable: true,
				loop: true
			});
		}
	},

	unload: function() {
		if ($('ref:planningSwiper').length) {
			this.planningSwiper.destroy();
		}
	}
});